// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BlockingPeriodSearchResponse

import { hydrateBlockingPeriod, type BlockingPeriod, type BlockingPeriodApiResponse } from './blockingPeriod.gen';

export type BlockingPeriodSearchApiResponse = {
	items: BlockingPeriodApiResponse[];
};

export type BlockingPeriodSearch = {
	items: BlockingPeriod[];
};

export function hydrateBlockingPeriodSearch(data: BlockingPeriodSearchApiResponse): BlockingPeriodSearch {
	return {
		...data,
		items: data.items.map(hydrateBlockingPeriod),
	};
}